module.exports = __webpack_public_path__ + "static/media/logotype_jumbotron.f4d9eb7e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/main/logotype_jumbotron.svg
// module id = 963
// module chunks = 124